import i18n from '@/i18n/i18n';

export const purchaseStatus = {
	accepted: 1,
	pending: 2,
	rejected: 3,
}

export const receiveStatus = {
	unReceived: 1,
	received: 2,
}

export const type = {
	main: 0,
	sub: 1,
}

export const types = [
	{ id: 0, name: i18n.t('types.main') },
	{ id: 1, name: i18n.t('types.sub') }
];

export const accountConfig = {
	owners: 0,
	providers: 1,
	customers: 2,
	detachment: 3,
}
export const itemConfig = {
	rawCardamom: 0,
	cardamomRoot: 1,
	crush: 2,
	seeds: 3,
}

export const configs = {
	owners: 1,
	providers: 2,
	customers: 3,
	detachment: 4,
	rawCardamom: 5,
	cardamomRoot: 6,
	crush: 7,
	seeds: 8,
}

export const permission = {
	sales: 0,
	managingInventory: 1,
	managingItems: 2,
	managingUsers: 3,
	managingAccounts: 4,
	managingPurchases: 5,
	managingSimulations: 6,
	managingReceives: 7,
	viewStatistics: 8,
	fiscalYears: 9,
	materialJournal: 10,
	managingSettings: 11,
	managingProductionOrders: 12,
	managingOrderResults: 13,
	managingItemsStatement: 14,
	managingExperimentalSimulation: 15,
	managingMaterialSimulation: 16,
	managingReceivingJournals: 17,
	managingDeliveryJournals: 18
}

export const actionType = {
	none: 0,
	read: 1,
	readAndWrite: 2,
}

export const materialJournalType = {
	receiving: 1,
	rawSorting: 2,
	sortingResults: 3,
	delivery: 4,
}

export const productionType = {
	order: 0,
	results: 1,
}

export const cardamomStatus = {
	inSorting: 0,
	raw: 1
}

export const itemCategory = {
	commercial: 0,
	nonCommercial: 1
}
